/* =====================================================================
   KASHMIRI HARISSA — Landing page behaviour
   ---------------------------------------------------------------------
   No libraries. Everything is progressive enhancement: without this
   file the page is fully readable, forms still post to Shopify, and
   the FAQ still opens.

   LAUNCH DATE: the countdown reads the date from the section setting
   "Launch date & time" (theme editor), passed in through the
   data-launch attribute. There is nothing to edit here.
   ===================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('kh-js');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------------
     1. Countdown
     The launch moment is an ISO-8601 string with an explicit UTC
     offset (e.g. 2026-11-30T00:00:00+05:30 = midnight in Kashmir),
     so every visitor, in any timezone, counts down to the same
     instant.
     --------------------------------------------------------------- */
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function parseLaunch(str) {
    var t = Date.parse(str);
    if (!isNaN(t)) return t;
    // Safari-safe fallback for "YYYY-MM-DDTHH:MM:SS+HH:MM"
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?([+-])(\d{2}):?(\d{2})$/.exec(str || '');
    if (!m) return NaN;
    var utc = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
    var off = (+m[8] * 60 + +m[9]) * 60000 * (m[7] === '+' ? 1 : -1);
    return utc - off;
  }

  var timers = $$('[data-kh-countdown]').map(function (el) {
    return {
      el: el,
      target: parseLaunch(el.getAttribute('data-launch')),
      nodes: {
        days: $('[data-unit="days"]', el),
        hours: $('[data-unit="hours"]', el),
        minutes: $('[data-unit="minutes"]', el),
        seconds: $('[data-unit="seconds"]', el)
      },
      last: {}
    };
  });

  function renderTimers() {
    var now = Date.now();
    var allDone = true;
    timers.forEach(function (t) {
      if (isNaN(t.target)) { t.el.setAttribute('data-invalid', ''); return; }
      var diff = Math.max(0, t.target - now);
      if (diff <= 0) {
        if (!t.el.classList.contains('is-done')) {
          t.el.classList.add('is-done');
          document.dispatchEvent(new CustomEvent('kh:launched'));
        }
        return;
      }
      allDone = false;
      var s = Math.floor(diff / 1000);
      var v = {
        days: Math.floor(s / 86400),
        hours: Math.floor((s % 86400) / 3600),
        minutes: Math.floor((s % 3600) / 60),
        seconds: s % 60
      };
      Object.keys(v).forEach(function (k) {
        var node = t.nodes[k];
        if (!node) return;
        var txt = k === 'days' ? (v[k] < 100 ? pad(v[k]) : String(v[k])) : pad(v[k]);
        if (t.last[k] !== txt) {
          node.textContent = txt;
          if (!reduceMotion && t.last[k] !== undefined && k !== 'seconds') {
            node.classList.remove('is-tick'); void node.offsetWidth; node.classList.add('is-tick');
          }
          t.last[k] = txt;
        }
      });
    });
    return allDone;
  }

  if (timers.length) {
    renderTimers();
    // Align ticks to the wall-clock second so all timers change together.
    var tick = function () {
      var done = renderTimers();
      if (!done) setTimeout(tick, 1000 - (Date.now() % 1000) + 8);
    };
    setTimeout(tick, 1000 - (Date.now() % 1000) + 8);
    // Re-sync after the tab has been in the background (mobile browsers pause timers).
    document.addEventListener('visibilitychange', function () { if (!document.hidden) renderTimers(); });
  }

  /* ---------------------------------------------------------------
     2. Navigation: transparent → solid on scroll, mobile menu
     --------------------------------------------------------------- */
  var nav = $('[data-kh-nav]');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('is-solid', window.scrollY > 40); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var burger = $('[data-kh-burger]');
  var menu = $('[data-kh-menu]');
  function setMenu(open) {
    if (!burger || !menu) return;
    burger.setAttribute('aria-expanded', String(open));
    burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    if ('inert' in menu) menu.inert = !open;
    document.body.classList.toggle('kh-lock', open);
    if (nav) nav.classList.toggle('is-solid', open || window.scrollY > 40);
    if (open) { var first = $('a', menu); if (first) first.focus({ preventScroll: true }); }
  }
  if (burger && menu) {
    if ('inert' in menu) menu.inert = true;
    burger.addEventListener('click', function () { setMenu(burger.getAttribute('aria-expanded') !== 'true'); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) { setMenu(false); burger.focus(); }
    });
  }

  /* ---------------------------------------------------------------
     3. "Join the First Batch" CTAs
     Every CTA with data-kh-join scrolls to the First Batch section,
     opens the sign-up panel and puts the cursor in the first field.
     After launch (store switched to live in the theme editor) the
     CTAs become normal links to your shop and this is skipped.
     --------------------------------------------------------------- */
  var panel = $('[data-kh-panel]');
  var panelToggle = $('[data-kh-panel-toggle]');

  function openPanel(focus) {
    if (!panel) return;
    panel.classList.add('is-open');
    panel.removeAttribute('aria-hidden');
    if ('inert' in panel) panel.inert = false;
    if (panelToggle) panelToggle.setAttribute('aria-expanded', 'true');
    if (focus) {
      var field = $('input:not([type="hidden"])', panel);
      if (field) setTimeout(function () { field.focus({ preventScroll: true }); }, reduceMotion ? 0 : 650);
    }
  }
  if (panel && panel.hasAttribute('data-collapsible')) {
    // Keep the panel open if the page reloaded after a submission or an error.
    var keepOpen = panel.querySelector('.kh-form__error:not([hidden]), .kh-form__success:not([hidden])') ||
      /customer_posted=true/.test(location.search) || panel.hasAttribute('data-open');
    if (keepOpen) openPanel(false);
    else { panel.setAttribute('aria-hidden', 'true'); if ('inert' in panel) panel.inert = true; }
  }
  if (panelToggle) {
    panelToggle.addEventListener('click', function (e) {
      e.preventDefault();
      openPanel(true);
    });
  }

  $$('[data-kh-join]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = $('#first-batch');
      if (!target) return;
      e.preventDefault();
      var anchor = panel ? panel.closest('.kh-batch__copy') || target : target;
      anchor.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      openPanel(true);
      if (history.replaceState) history.replaceState(null, '', '#first-batch');
    });
  });

  /* ---------------------------------------------------------------
     4. Sign-up forms → Shopify customer / newsletter
     Forms are real Shopify {% form 'customer' %} forms, so they work
     without JavaScript. With JS we submit in the background to avoid
     a page reload and show the success / error state in place.
     --------------------------------------------------------------- */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function showError(form, msg) {
    var box = $('[data-kh-error]', form);
    var text = $('[data-kh-error-text]', form);
    var email = $('input[type="email"]', form);
    if (text) text.textContent = msg; else if (box) box.textContent = msg;
    if (box) box.hidden = false;
    if (email) { email.setAttribute('aria-invalid', 'true'); email.focus(); }
  }
  function clearError(form) {
    var box = $('[data-kh-error]', form);
    var email = $('input[type="email"]', form);
    if (box) box.hidden = true;
    if (email) email.removeAttribute('aria-invalid');
  }
  function showSuccess(form) {
    form.classList.add('is-success');
    var ok = $('.kh-form__success', form);
    if (ok) { ok.hidden = false; ok.setAttribute('tabindex', '-1'); ok.focus({ preventScroll: true }); }
    var fields = $('.kh-form__fields', form);
    if (fields) fields.hidden = true;
  }
  function friendly(msg) {
    if (!msg) return 'Something went wrong. Please try again.';
    if (/taken|already/i.test(msg)) return "You're already on the list. We'll be in touch when the First Winter Batch is ready.";
    if (/invalid/i.test(msg)) return 'Please enter a valid email address, for example name@example.com.';
    return msg;
  }

  $$('form[data-kh-form]').forEach(function (form) {
    var email = $('input[type="email"]', form);
    if (email) email.addEventListener('input', function () { clearError(form); });

    form.addEventListener('submit', function (e) {
      clearError(form);
      var value = email ? email.value.trim() : '';
      if (!EMAIL_RE.test(value)) {
        e.preventDefault();
        showError(form, value ? 'Please enter a valid email address, for example name@example.com.' : 'Please enter your email address.');
        return;
      }
      if (email) email.value = value;
      if (!window.fetch || !window.FormData || !window.DOMParser) return; // native submit

      e.preventDefault();
      var btn = $('button[type="submit"]', form);
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding you…'; }
      var restore = function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; } };

      if (window.KH_PREVIEW) { setTimeout(function () { restore(); showSuccess(form); }, 700); return; }

      fetch(form.getAttribute('action') || '/contact', {
        method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' }
      }).then(function (res) {
        // Shopify sometimes asks for a CAPTCHA. Hand over to a normal submit so the visitor sees it.
        if (/\/challenge/.test(res.url)) { form.submit(); return null; }
        if (/customer_posted=true/.test(res.url)) { restore(); showSuccess(form); return null; }
        return res.text();
      }).then(function (html) {
        if (html === null || html === undefined) return;
        restore();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var same = form.id ? doc.getElementById(form.id) : null;
        var ok = same && same.querySelector('.kh-form__success:not([hidden])');
        if (ok) { showSuccess(form); return; }
        var err = same && same.querySelector('[data-kh-error-text]');
        showError(form, friendly(err ? err.textContent.trim() : ''));
      }).catch(function () {
        restore();
        form.submit(); // network hiccup: fall back to a normal post
      });
    });
  });

  /* ---------------------------------------------------------------
     5. Scroll reveals
     --------------------------------------------------------------- */
  var revealEls = $$('[data-reveal]');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------------------------------------------------------------
     6. Gentle parallax (desktop, motion allowed only)
     --------------------------------------------------------------- */
  var px = $$('[data-kh-parallax]');
  if (px.length && !reduceMotion && window.matchMedia('(min-width: 901px)').matches) {
    var ticking = false;
    var update = function () {
      var vh = window.innerHeight;
      px.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var speed = parseFloat(el.getAttribute('data-kh-parallax')) || 0.12;
        var offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------------------------------------------------------------
     7. FAQ: one open at a time (native <details>, no JS needed to use)
     --------------------------------------------------------------- */
  $$('[data-kh-faq] details').forEach(function (d, i, all) {
    d.addEventListener('toggle', function () {
      if (d.open) all.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });

  /* Footer year */
  $$('[data-kh-year]').forEach(function (el) { el.textContent = new Date().getFullYear(); });
})();
